/** @jsxImportSource @emotion/react */
import { formatFecha } from "../../utils";
import { Card } from "primereact/card";

import { Tag } from "primereact/tag";

export default function EstadoCertificado({
  vigente,
  pendiente,
  suspendido,
  anulado,
  sinRenovacion,
  fechaEmision
}) {
  let background = "";
  let texto = "";
  let tagColor = "";
  let tagTexto = "";
  if (vigente) {
    background = "var(--verdeLight)";
    tagColor = "var(--verde)";
    tagTexto = "Vigente";
    if (fechaEmision) {
      texto = `Certificado emitido en ${formatFecha(fechaEmision)}`;
    } else {
      texto = "Certificado vigente";
    }
  } else if (pendiente) {
    background = "var(--amarilloLight)";
    texto = "Certificado no emitido";
    tagColor = "var(--amarillo)";
    tagTexto = "Pendiente";
  } else if (suspendido) {
    background = "var(--amarilloLight)";
    texto = "Certificado suspendido";
    tagColor = "var(--amarillo)";
    tagTexto = "Suspendido";
  } else if (anulado) {
    background = "var(--rojoLight)";
    texto = "Certificado anulado";
    tagColor = "var(--rojo)";
    tagTexto = "Anulado";
  }

  return (
    <>
      {(vigente || pendiente || anulado || suspendido) && (
        <Card
          css={{ background, height: "fit-content", boxSizing: "border-box" }}
        >
          <div
            css={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              "@media (max-width: 768px)": { justifyContent: "center" }
            }}
          >
            <p
              className="m-0"
              css={{
                alignSelf: "center",
                "@media (max-width: 768px)": { display: "none" }
              }}
            >
              {texto}
            </p>
            <div
              css={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                justifyContent: "flex-end",
                alignItems: "center"
              }}
            >
              {sinRenovacion && (
                <Tag
                  value="No se renueva"
                  icon="pi pi-ban"
                  css={{
                    height: "fit-content",
                    backgroundColor: "var(--rojo)",
                    color: "#ffffff"
                  }}
                ></Tag>
              )}
              <Tag
                value={tagTexto}
                css={{
                  height: "fit-content",
                  backgroundColor: tagColor,
                  color: "#ffffff"
                }}
              ></Tag>
            </div>
          </div>
        </Card>
      )}
    </>
  );
}
